import React, { useEffect, useState } from 'react';

const loadEditor = async (
  setEditor: (Editor: { Editor: any }) => void
): Promise<void> => {
  // loading it on the header breaks server-side rendering
  // https://github.com/ckeditor/ckeditor5/issues/1511
  const editorModule = await import('./EditorComponent');

  setEditor({
    Editor: editorModule.EditorComponent,
  });
};

interface EditorProps {
  readOnly?: boolean;
  setData: (data: string) => void;
  setInitialData: (data: string) => void;
  value?: string;
}

export const Editor = ({
  setInitialData,
  setData,
  readOnly,
  value,
}: EditorProps): React.ReactElement => {
  const [{ Editor }, setEditor] = useState({
    Editor: null,
  });

  useEffect(() => {
    loadEditor(setEditor);
  }, []);

  const component = Editor ? (
    <Editor
      setInitialData={setInitialData}
      value={value}
      readOnly={readOnly}
      setData={setData}
    />
  ) : null;

  return component;
};
